<template>
  <div v-if="type === optionValue.sex">
    <common-multi-selector
      v-if="multiple"
      :data-source="sexOptionsProxy"
      :value="value"
      @change="handleChange"
    />
    <common-single-selector
      v-else-if="mode === modeValue.single"
      :data-source="sexOptionsProxy"
      :value="value"
      @change="handleChange"
    />
    <div v-else>不支持的输入模式</div>
  </div>
  <div v-else-if="type === optionValue.currency">
    <common-multi-selector
      v-if="multiple"
      :data-source="currencyOptionsProxy"
      :value="value"
      @change="handleChange"
    />
    <common-single-selector
      v-else-if="mode === modeValue.single"
      :data-source="currencyOptionsProxy"
      :value="value"
      @change="handleChange"
    />
    <div v-else>不支持的输入模式</div>
  </div>
  <div v-else-if="type === optionValue.money"></div>
  <div v-else-if="type === optionValue.other">
    <common-multi-selector
      v-if="multiple"
      :data-source="customSource"
      :value="value"
      @change="handleChange"
    />
    <common-single-selector
      v-else-if="mode === modeValue.single"
      :data-source="customSource"
      :value="value"
      @change="handleChange"
    />
    <el-input
      v-else-if="mode === modeValue.text"
      :rows="1"
      size="mini"
      autofocus
      type="textarea"
      :value="value"
      @input="handleChange"
    />
    <el-input-number
      v-else-if="mode === modeValue.number"
      size="mini"
      autofocus
      controls-position="right"
      :value="value"
      @change="handleChange"
      style="width: auto;"
    />
    <el-checkbox
      v-else-if="mode === modeValue.check"
      size="mini"
      autofocus
      :checked="value"
      @change="handleChange"
    />
  </div>
  <div v-else>不支持的类型</div>
</template>
<script>
import { Input, InputNumber, Checkbox } from "element-ui";

import { SexOption } from "@/components/excel/schema/value/type/other.ts";
import {
  CurrencyOption,
  MoneyOption,
  OtherOption,
} from "@/components/excel/schema/value/type/other";
import {
  MultiSelector,
  SingleSelector,
  TextInput,
  NumberInput,
  Check,
} from "@/components/excel/schema/value/mode";
import { SexSelector } from "@/components/excel/schema/selector/sex.ts";
import { CurrencySelector } from "@/components/excel/schema/selector/currency.ts";
import CommonMultiSelector from "@/components/selector/CommonMultiSelector";
import CommonSingleSelector from "@/components/selector/CommonSingleSelector";
import {
  findOptionsText,
  findOptionText,
} from "@/utils/excel/CommonDataSource";
import {
  assembleCommonDisabled,
  filterCommonAllowed,
  filterCommonHidden,
} from "@/utils/excel/OptionFilter";

export default {
  name: "grid-other-editor",
  components: {
    CommonSingleSelector,
    CommonMultiSelector,
    [InputNumber.name]: InputNumber,
    [Input.name]: Input,
    [Checkbox.name]: Checkbox,
  },
  props: {
    type: {
      type: Number,
    },
    text: {
      type: String,
    },
    value: {
      type: [Array, Number, String, Boolean],
    },
    mode: {
      type: Number,
    },
    options: Array,
    disabledItems: Array,
    hiddenItems: Array,
  },
  data() {
    return {
      optionValue: {
        sex: SexOption.value,
        currency: CurrencyOption.value,
        money: MoneyOption.value,
        other: OtherOption.value,
      },
      modeValue: {
        single: SingleSelector.value,
        multi: MultiSelector.value,
        text: TextInput.value,
        number: NumberInput.value,
        check: Check.value,
      },
      selectorOptions: {
        sex: SexSelector.options,
        currency: CurrencySelector.options,
      },
    };
  },
  computed: {
    multiple() {
      return this.mode === this.modeValue.multi;
    },
    customSource() {
      const { options, disabledItems, hiddenItems } = this.$props;
      if (!Array.isArray(options) || !options.length) {
        return [];
      }
      const list = options.map((it) => {
        return { value: it.order, text: it.text };
      });
      const filter = filterCommonHidden(list, hiddenItems);
      return assembleCommonDisabled(filter, disabledItems);
    },
    sexOptionsProxy() {
      return this.filterAllowedItems(this.selectorOptions.sex);
    },
    currencyOptionsProxy() {
      return this.filterAllowedItems(this.selectorOptions.currency);
    },
  },
  methods: {
    filterAllowedItems(items) {
      if (!Array.isArray(items) || !items.length) {
        return items;
      }
      const { disabledItems, hiddenItems, options } = this.$props;
      const list = filterCommonAllowed(items, options);
      const filter = filterCommonHidden(list, hiddenItems);
      return assembleCommonDisabled(filter, disabledItems);
    },
    handleChange(value) {
      const text = this.obtainText(value);
      this.$emit("change", { value, text });
    },
    obtainText(value) {
      if (this.multiple) {
        if (this.type === this.optionValue.sex) {
          return findOptionsText(this.selectorOptions.sex, value);
        }
        if (this.type === this.optionValue.currency) {
          return findOptionsText(this.selectorOptions.currency, value);
        }
        if (this.type === this.optionValue.other){
          return findOptionsText(this.customSource, value)
        }
        return value;
      }
      if (this.type === this.optionValue.sex) {
        return findOptionText(this.selectorOptions.sex, value);
      }
      if (this.type === this.optionValue.currency) {
        return findOptionText(this.selectorOptions.currency, value);
      }
      const { type, optionValue, mode, modeValue } = this;
      if (type === optionValue.other && mode === modeValue.single){
        return findOptionText(this.customSource, value);
      }
      // 如果是其他类型  在填表的时候用不上，但是在制表时能用上
      return value;
    },
  },
};
</script>
